import axios from "axios";
import _ from "lodash";
import { API_GATEWAY_URL } from "../config/constants";
import moment from 'moment';
import { setSpeakers } from "../store/Actions/Event/eventActions";


export const fetchSchedules = async (eventId: string,dispatch:any) => {
  try {


    
    const endpoints = {
      livePresentation: `${API_GATEWAY_URL}frontend/api/live-presentation/event-id/${eventId}`,
      roundTable: `${API_GATEWAY_URL}frontend/api/round-table/event-id/${eventId}`,
      panelDiscussion: `${API_GATEWAY_URL}frontend/api/panel-discussions/event-id/${eventId}`,
      displayCenter: `${API_GATEWAY_URL}frontend/api/display-center/event-id/${eventId}`,
    };

    const roundRes = await axios.get(`${API_GATEWAY_URL}frontend/api/round-table/event-id/${eventId}`);
    const [liveRes, panelRes,displayCenterRes] = await Promise.all([
      axios.get(endpoints.livePresentation),
     // axios.get(endpoints.roundTable),
      axios.get(endpoints.panelDiscussion),
      axios.get(endpoints.displayCenter),
      
    ]);

    const format = (data, type) => _.map(data, d => ({ ...d, type }));

    const livePresentations = format(_.get(liveRes, 'data.data', []), 'live-presentation');
    const roundTables = format(_.get(roundRes, 'data.data', []), 'round-table');
    const panelDiscussions = format(_.get(panelRes, 'data.data', []), 'panel-discussion');
    const displayCenter = format(_.get(displayCenterRes, 'data.data', []), 'display-center');
  
    const foundSpeakerLive = livePresentations?.find((item) => item.speaker);
    const foundSpeakerRound = roundTables?.find((item) => item.speaker);

    const speakers = [];

    if (foundSpeakerLive?.speaker) speakers.push(foundSpeakerLive.speaker);
    if (foundSpeakerRound?.speaker) speakers.push(foundSpeakerRound.speaker);

    dispatch(setSpeakers(speakers));

    const allData = _.unionBy(
      [...livePresentations, ...roundTables, ...panelDiscussions,...displayCenter],
      '_id'
    );

    const sortedStartTimes = _.sortBy(allData, 'start_time').map(item => item.start_time);
    sortedStartTimes.push('9090-03-14T11:44:00.000Z'); // dummy date for loop closure

    let schedulesObj = [];
    let previous = false;
    let next = false;
    let start_day = null;
    let end_day = null;
    let start_date_time = null;
    let end_date_time = null;

    let data = [];
    let dataRoundTable = [];
    let dataPanelDiscussion = [];
    let dataDisplayCenter = [];
    //let dataOnDemand = [];

    sortedStartTimes.forEach((time, index) => {
      const currentDateData = _.filter(allData, { start_time: time });

      if (!_.isEmpty(currentDateData) || index === sortedStartTimes.length - 1) {
        if (!next && !previous) {
          previous = moment(time);
          next = moment(time);
          start_day = previous.format('DD');
          end_day = previous.format('DD');
          start_date_time = previous.format('DD-MMMM-YYYY');
          end_date_time = previous.format('DD-MMMM-YYYY');
        } else {
          previous = moment(sortedStartTimes[index - 1]);
          next = moment(time);
        }

        const days = next.diff(previous, 'days');

        if (days <= 1) {
          // Push unique items only
          const currentLive = _.filter(currentDateData, { type: 'live-presentation' });
          currentLive.forEach(item => {
            if (!data.find(existing => existing._id === item._id)) {
              data.push(item);
            }
          });

          const currentRound = _.filter(currentDateData, { type: 'round-table' });
          currentRound.forEach(item => {
            if (!dataRoundTable.find(existing => existing._id === item._id)) {
              dataRoundTable.push(item);
            }
          });

          const currentPanel = _.filter(currentDateData, { type: 'panel-discussion' });
          currentPanel.forEach(item => {
            if (!dataPanelDiscussion.find(existing => existing._id === item._id)) {
              dataPanelDiscussion.push(item);
            }
          });

          const currentDisplay = _.filter(currentDateData, { type: 'display-center' });
          currentDisplay.forEach(item => {
            if (!dataDisplayCenter.find(existing => existing._id === item._id)) {
              dataDisplayCenter.push(item);
            }
          });

          

        } else {
          // Finalize current block
          end_day = previous.format('DD');
          end_date_time = previous.format('DD-MMMM-YYYY');
          const keyIndex = previous.format('MMMM');
          const key = (start_day === end_day) ? end_day : `${start_day}_${end_day}`;

          schedulesObj.push({
            start: start_day,
            end: previous.format('dd'),
            key,
            month: keyIndex,
            label: `${keyIndex} ${key.replace('_', '-')}`,
            start_date_time,
            end_date_time,
            data,
            dataRoundTable,
            dataPanelDiscussion,
            dataDisplayCenter
            
          });

          // Reset for new group
          start_day = next.format('DD');
          start_date_time = next.format('DD-MMMM-YYYY');
          data = [];
          dataRoundTable = [];
          dataPanelDiscussion = [];
          dataDisplayCenter=[]
      
          // Start new group with current data
          const currentLive = _.filter(currentDateData, { type: 'live-presentation' });
          currentLive.forEach(item => data.push(item));

          const currentRound = _.filter(currentDateData, { type: 'round-table' });
          currentRound.forEach(item => dataRoundTable.push(item));

          const currentPanel = _.filter(currentDateData, { type: 'panel-discussion' });
          currentPanel.forEach(item => dataPanelDiscussion.push(item));

          const currentDisplay = _.filter(currentDateData, { type: 'display-center' });
          currentDisplay.forEach(item => dataDisplayCenter.push(item));

        }
      }
    });
    return schedulesObj;
  } catch (error) {
    console.error("Error fetching schedules:", error);
    return [];
  }
};

export const fetchSchedulesX = async (eventId: string,dispatch:any) => {
  try {

    const endpoints = {
      livePresentation: `${API_GATEWAY_URL}frontend/api/live-presentation/event-id/${eventId}`,
      roundTable: `${API_GATEWAY_URL}frontend/api/round-table/event-id/${eventId}`,
      panelDiscussion: `${API_GATEWAY_URL}frontend/api/panel-discussions/event-id/${eventId}`,
      onDemand: `${API_GATEWAY_URL}frontend/api/agenda-on-demand/event-id/${eventId}`
    };

    const [liveRes, roundRes, panelRes, onDemandRes] = await Promise.all([
      axios.get(endpoints.livePresentation),
      axios.get(endpoints.roundTable),
      axios.get(endpoints.panelDiscussion),
      axios.get(endpoints.onDemand)
    ]);

    const format = (data, type) => _.map(data, d => ({ ...d, type }));

    const livePresentations = format(_.get(liveRes, 'data.data', []), 'live-presentation');
    const roundTables = format(_.get(roundRes, 'data.data', []), 'round-table');
    const panelDiscussions = format(_.get(panelRes, 'data.data', []), 'panel-discussion');
    const onDemand = format(_.get(onDemandRes, 'data.data', []), 'on-demand');

    const foundSpeakerLive = livePresentations?.find((item) => item.speaker);
    const foundSpeakerRound = roundTables?.find((item) => item.speaker);

    const speakers = [];

    if (foundSpeakerLive?.speaker) speakers.push(foundSpeakerLive.speaker);
    if (foundSpeakerRound?.speaker) speakers.push(foundSpeakerRound.speaker);

    dispatch(setSpeakers(speakers));

    const allData = _.unionBy(
      [...livePresentations, ...roundTables, ...panelDiscussions, ...onDemand],
      '_id'
    );

    const sortedStartTimes = _.sortBy(allData, 'start_time').map(item => item.start_time);
    sortedStartTimes.push('9090-03-14T11:44:00.000Z'); // dummy date for loop closure

    let schedulesObj = [];
    let previous = false;
    let next = false;
    let start_day = null;
    let end_day = null;
    let start_date_time = null;
    let end_date_time = null;

    let data = [];
    let dataRoundTable = [];
    let dataPanelDiscussion = [];
    //let dataOnDemand = [];

    sortedStartTimes.forEach((time, index) => {
      const currentDateData = _.filter(allData, { start_time: time });

      if (!_.isEmpty(currentDateData) || index === sortedStartTimes.length - 1) {
        if (!next && !previous) {
          previous = moment(time);
          next = moment(time);
          start_day = previous.format('DD');
          end_day = previous.format('DD');
          start_date_time = previous.format('DD-MMMM-YYYY');
          end_date_time = previous.format('DD-MMMM-YYYY');
        } else {
          previous = moment(sortedStartTimes[index - 1]);
          next = moment(time);
        }

        const days = next.diff(previous, 'days');

        if (days <= 1) {
          // Push unique items only
          const currentLive = _.filter(currentDateData, { type: 'live-presentation' });
          currentLive.forEach(item => {
            if (!data.find(existing => existing._id === item._id)) {
              data.push(item);
            }
          });

          const currentRound = _.filter(currentDateData, { type: 'round-table' });
          currentRound.forEach(item => {
            if (!dataRoundTable.find(existing => existing._id === item._id)) {
              dataRoundTable.push(item);
            }
          });

          const currentPanel = _.filter(currentDateData, { type: 'panel-discussion' });
          currentPanel.forEach(item => {
            if (!dataPanelDiscussion.find(existing => existing._id === item._id)) {
              dataPanelDiscussion.push(item);
            }
          });

          const currentOnDemand = _.filter(currentDateData, { type: 'on-demand' });
          currentOnDemand.forEach(item => {
            if (!dataOnDemand.find(existing => existing._id === item._id)) {
              dataOnDemand.push(item);
            }
          });

        } else {
          // Finalize current block
          end_day = previous.format('DD');
          end_date_time = previous.format('DD-MMMM-YYYY');
          const keyIndex = previous.format('MMMM');
          const key = (start_day === end_day) ? end_day : `${start_day}_${end_day}`;

          schedulesObj.push({
            start: start_day,
            end: previous.format('dd'),
            key,
            month: keyIndex,
            label: `${keyIndex} ${key.replace('_', '-')}`,
            start_date_time,
            end_date_time,
            data,
            dataRoundTable,
            dataPanelDiscussion,
            dataOnDemand
          });

          // Reset for new group
          start_day = next.format('DD');
          start_date_time = next.format('DD-MMMM-YYYY');
          data = [];
          dataRoundTable = [];
          dataPanelDiscussion = [];
          dataOnDemand = [];

          // Start new group with current data
          const currentLive = _.filter(currentDateData, { type: 'live-presentation' });
          currentLive.forEach(item => data.push(item));

          const currentRound = _.filter(currentDateData, { type: 'round-table' });
          currentRound.forEach(item => dataRoundTable.push(item));

          const currentPanel = _.filter(currentDateData, { type: 'panel-discussion' });
          currentPanel.forEach(item => dataPanelDiscussion.push(item));

          const currentOnDemand = _.filter(currentDateData, { type: 'on-demand' });
          currentOnDemand.forEach(item => dataOnDemand.push(item));
        }
      }
    });

    return schedulesObj;
  } catch (error) {
    console.error("Error fetching schedules:", error);
    return [];
  }
};


export const fetchHighLights = async (eventId: string) => {
  try {

    const endpoints = {
      onDemand: `${API_GATEWAY_URL}frontend/api/agenda-on-demand/event-id/${eventId}`
    };
    const [onDemandRes] = await Promise.all([
      axios.get(endpoints.onDemand)
    ]);

    const onDemand = _.get(onDemandRes, 'data.data', []);

    const allData = _.unionBy(
      [...onDemand],
      '_id'
    );

    return allData;
  } catch (error) {
    console.error("Error fetching schedules:", error);
    return [];
  }
};


